import { create } from "zustand";
import { fetchStats, statsUserData } from "../api_layer/api";
import { statsData } from "../api_layer/api";
import { statsDateFilter } from "../api_layer/api";
import { fetchDataDownload } from "../api_layer/api";

const useTicketStatsStore = create((set) => ({
    statsData: [],
    downloadData:[],
    userData:[],
    statsLoading: false,
    error: null,
    fetchStatsData: async (sd, ed) => {
        try {
          set({ statsLoading: true, error: null });
          const response = await statsData(sd, ed);
          set({ statsData: response.data, statsLoading: false });
        } catch (error) {
          set({ error: error.message, statsLoading: false });
        }
      },
      fetchAssignedStatsData: async (sd, ed, payload) => {
        try {
          set({ statsLoading: true, error: null });
          const response = await fetchStats(sd, ed, payload);
          set({ statsData: response.data, statsLoading: false });
        } catch (error) {
          set({ error: error.message, statsLoading: false });
        }
      },
      fetchStatsFilterDate: async (sd, ed) => {
        try {
          set({ statsLoading: true, error: null });
          const response = await statsDateFilter(sd, ed);
          set({ statsData: response.data, statsLoading: false });
        } catch (error) {
          set({ error: error.message, statsLoading: false });
        }
      },
      fetchUserData: async () => {
        try {
          set({ isLoading: false, error: null });
          const response = await statsUserData();
          set({ userData: response.data, isLoading: false });
        } catch (error) {
          set({ error: error.message, isLoading: false });
        }
      },
      fetchDownloads: async (sd, ed) => {
        try {
          set({ isLoading: true, error: null });
          const response = await fetchDataDownload(sd, ed);
          set({ downloadData: response.data, isLoading: false });
        } catch (error) {
          set({ error: error.message, isLoading: false });
        }
      },
      

  }));
  
  export default useTicketStatsStore;
  